import React from 'react';

import QuickAddDrawer from './product/QuickAddDrawer';
import CartDrawer from './overlays/CartDrawer';
import SearchPanel from './overlays/SearchPanel';
import AgentPill from '../ai/AgentPill';
import AgentPanel from '../ai/AgentPanel';

// Storefront overlays opened from anywhere through ShopUIContext
const ShopOverlays = () => (
  <>
    <QuickAddDrawer />
    <CartDrawer />
    <SearchPanel />
    <AgentPill />
    <AgentPanel />
  </>
);

export default ShopOverlays;
